/**
 * @flow
 * @relayHash f416e3a9f4fab3cf9d8c227dd46ce9b8
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type NonIndexablePagesTable_project$ref = any;
export type FilterOperator = "AND" | "OR" | "%future added value";
export type TextFilterOperator = "CONTAINS" | "NOT_CONTAINS" | "REGEXP" | "%future added value";
export type SitemapFilter = {
  showInSitemap?: ?boolean,
  showNotInSitemap?: ?boolean,
};
export type TextFilters = {
  operator: FilterOperator,
  values?: ?$ReadOnlyArray<?TextFilter>,
};
export type TextFilter = {
  operator: TextFilterOperator,
  value: string,
};
export type NonIndexablePagesTable_RefetchQueryVariables = {|
  host: string,
  limit?: ?number,
  offset?: ?number,
  sitemapFilter?: ?SitemapFilter,
  noindexTypeFilters?: ?$ReadOnlyArray<?string>,
  sourceUrl?: ?TextFilters,
  url?: ?TextFilters,
|};
export type NonIndexablePagesTable_RefetchQueryResponse = {|
  +project: ?{|
    +$fragmentRefs: NonIndexablePagesTable_project$ref
  |}
|};
export type NonIndexablePagesTable_RefetchQuery = {|
  variables: NonIndexablePagesTable_RefetchQueryVariables,
  response: NonIndexablePagesTable_RefetchQueryResponse,
|};
*/


/*
query NonIndexablePagesTable_RefetchQuery(
  $host: String!
  $limit: Int
  $offset: Int
  $sitemapFilter: SitemapFilter
  $noindexTypeFilters: [String]
  $sourceUrl: TextFilters
  $url: TextFilters
) {
  project(host: $host) {
    ...NonIndexablePagesTable_project_GHKKp
    id
  }
}

fragment NonIndexablePagesTable_project_GHKKp on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countNoindexTypesNoindexedPages(sitemapFilter: $sitemapFilter, url: $url, sourceUrl: $sourceUrl) {
          type
          count
        }
        noindexedPages(offset: $offset, limit: $limit, url: $url, sourceUrl: $sourceUrl, noindexTypeFilters: $noindexTypeFilters, sitemapFilter: $sitemapFilter) {
          count
          edges {
            node {
              ...NonIndexablePagesRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment NonIndexablePagesRow_issue on NoindexedPage {
  id
  type
  severity
  url
  source_url
  noindex_types
  sitemap_url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "limit",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sitemapFilter",
    "type": "SitemapFilter",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "noindexTypeFilters",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sourceUrl",
    "type": "TextFilters",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "url",
    "type": "TextFilters",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Variable",
  "name": "sitemapFilter",
  "variableName": "sitemapFilter",
  "type": "SitemapFilter"
},
v3 = {
  "kind": "Variable",
  "name": "sourceUrl",
  "variableName": "sourceUrl",
  "type": "TextFilters"
},
v4 = {
  "kind": "Variable",
  "name": "url",
  "variableName": "url",
  "type": "TextFilters"
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "NonIndexablePagesTable_RefetchQuery",
  "id": null,
  "text": "query NonIndexablePagesTable_RefetchQuery(\n  $host: String!\n  $limit: Int\n  $offset: Int\n  $sitemapFilter: SitemapFilter\n  $noindexTypeFilters: [String]\n  $sourceUrl: TextFilters\n  $url: TextFilters\n) {\n  project(host: $host) {\n    ...NonIndexablePagesTable_project_GHKKp\n    id\n  }\n}\n\nfragment NonIndexablePagesTable_project_GHKKp on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countNoindexTypesNoindexedPages(sitemapFilter: $sitemapFilter, url: $url, sourceUrl: $sourceUrl) {\n          type\n          count\n        }\n        noindexedPages(offset: $offset, limit: $limit, url: $url, sourceUrl: $sourceUrl, noindexTypeFilters: $noindexTypeFilters, sitemapFilter: $sitemapFilter) {\n          count\n          edges {\n            node {\n              ...NonIndexablePagesRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment NonIndexablePagesRow_issue on NoindexedPage {\n  id\n  type\n  severity\n  url\n  source_url\n  noindex_types\n  sitemap_url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "NonIndexablePagesTable_RefetchQuery",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "NonIndexablePagesTable_project",
            "args": [
              {
                "kind": "Variable",
                "name": "limit",
                "variableName": "limit",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "noindexTypeFilters",
                "variableName": "noindexTypeFilters",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "offset",
                "variableName": "offset",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "sitemapFilter",
                "variableName": "sitemapFilter",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "sourceUrl",
                "variableName": "sourceUrl",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "url",
                "variableName": "url",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "NonIndexablePagesTable_RefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0,
                "type": "Int"
              }
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countNoindexTypesNoindexedPages",
                        "storageKey": null,
                        "args": [
                          v2,
                          v3,
                          v4
                        ],
                        "concreteType": "CountType",
                        "plural": true,
                        "selections": [
                          v5,
                          v6
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "noindexedPages",
                        "storageKey": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "limit",
                            "variableName": "limit",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "noindexTypeFilters",
                            "variableName": "noindexTypeFilters",
                            "type": "[String]"
                          },
                          {
                            "kind": "Variable",
                            "name": "offset",
                            "variableName": "offset",
                            "type": "Int"
                          },
                          v2,
                          v3,
                          v4
                        ],
                        "concreteType": "NoindexedPageConnection",
                        "plural": false,
                        "selections": [
                          v6,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "NoindexedPageEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "NoindexedPage",
                                "plural": false,
                                "selections": [
                                  v7,
                                  v5,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "severity",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "noindex_types",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "sitemap_url",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v7
                    ]
                  }
                ]
              }
            ]
          },
          v7
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'abbf0674fde2cfac479d3741b4d5b74d';
module.exports = node;
